let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("arhgZ"), load("e3cZ9")]).then(() => parcelRequire('aVMo3'));